export default {

}

export const teacherPanelCardSettings = {
    getCardSettings: { method: 'get', url: 'teacher/panel-card-settings' },
}